import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { useMediaPlanMetadataApi } from './useMediaPlanMetadataApi.js';

export const useSidebarTreeApi = () => {
  const { data: mediaPlanMetadata } = useMediaPlanMetadataApi();

  const { data, ...rest } = useQuery({
    ...MediaPlan.getSidebarListQueryOptions({
      params: {
        mediaDataId: mediaPlanMetadata?.mediaDataId || '',
      },
    }),
    enabled: !!mediaPlanMetadata?.mediaDataId,
  });

  return { data: data?.data?.items[0], ...rest };
};
